import { useMemo } from 'react';
import type { ShadcnThemeConfig } from '@org/runtime-engine';

interface ThemeInjectorProps {
  theme?: ShadcnThemeConfig;
}

const SHADCN_THEME_VARIABLES: Array<{ token: keyof ShadcnThemeConfig; cssVariable: string }> = [
  { token: 'primary', cssVariable: '--primary' },
  { token: 'secondary', cssVariable: '--secondary' },
  { token: 'radius', cssVariable: '--radius' },
  { token: 'background', cssVariable: '--background' },
  { token: 'foreground', cssVariable: '--foreground' },
  { token: 'muted', cssVariable: '--muted' },
  { token: 'accent', cssVariable: '--accent' },
];

export function ThemeInjector({ theme }: ThemeInjectorProps) {
  const cssText = useMemo(() => {
    if (!theme) return null;

    const declarations = SHADCN_THEME_VARIABLES
      .map(({ token, cssVariable }) => {
        const value = theme[token];
        if (!value) return null;
        return `${cssVariable}: ${value};`;
      })
      .filter((value): value is string => Boolean(value));

    if (declarations.length === 0) return null;

    return `:root { ${declarations.join(' ')} }`;
  }, [theme]);

  if (!cssText) return null;

  return <style data-testid="tenant-theme-injector">{cssText}</style>;
}
